/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { ICON_CLASS } from '@sede-x/shell-ds-react-base';
const Flag = styled.svg``;
const BeBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" ref={ref} {...props}><g clipPath="url(#a)"><mask id="b" style={{
      maskType: "luminance"
    }} maskUnits="userSpaceOnUse" x={0} y={0} width={48} height={48}><path d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z" fill="#fff" /></mask><g mask="url(#b)"><path d="M0 0h15.656l3.582 23.681L15.655 48H0V0Z" fill="#333" /><path d="M32.344 0H48v48H32.344l-3.44-24 3.44-24Z" fill="#D80027" /><path d="M15.656 0h16.688v48H15.656V0Z" fill="#FFDA44" /></g></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h48v48H0z" /></clipPath></defs></svg>);
const Be = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Flag className={classNames(ICON_CLASS, className)} as={BeBase} {...rest} ref={ref} />);
export default Be;